import React from 'react';

import type { BaseInquiryDetail } from '@models/BookingInquiry';
import type {
  CustomsInstruction,
  CustomsInstructionForm,
  CustomsInstructionInsuranceForm,
} from '@models/next/CustomsInstruction';
import type { User } from '@models/User';
import type { ReactForm } from '@monoid-dev/mobx-zod-form-react';
import type { MessagesEither } from '@utils/errors';

export type InstructionSuccessfulAction =
  | 'save'
  | 'submit'
  | 'createCustomsRequest'
  | 'submitCustomsRequest'
  | 'urlSubmitCustomsRequest'
  | 'requireChange';

export interface CustomsInstructionContextValueBase {
  d2dNo: string;
  onGoBack?: () => void;
  onRefresh?: () => void;
}

export interface CustomsInstructionContextValue extends CustomsInstructionContextValueBase {
  savedInsuranceRef: React.MutableRefObject<CustomsInstructionInsuranceForm[]>;
  customsInstruction: CustomsInstruction;
  baseInquiryDetail: BaseInquiryDetail;
  user: User;
  form: ReactForm<typeof CustomsInstructionForm>;
  canEditAsSalesperson: MessagesEither;
  isEditing: boolean;
  setIsEditing: (v: boolean) => void;
  successfulAction?: InstructionSuccessfulAction;
  setSuccessfulAction: (action: InstructionSuccessfulAction) => void;
}

export const CustomsInstructionContext = React.createContext<CustomsInstructionContextValue>(
  undefined as any,
);
